import { render, staticRenderFns } from "./SettingConfig.vue?vue&type=template&id=20efa3ac&scoped=true&"
import script from "./SettingConfig.vue?vue&type=script&lang=js&"
export * from "./SettingConfig.vue?vue&type=script&lang=js&"
import style0 from "./SettingConfig.vue?vue&type=style&index=0&id=20efa3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efa3ac",
  null
  
)

export default component.exports